<main class="main-container">
    <div class="loading" *ngIf="loading == true">Loading&#8230;</div>
    <div class="row paragraph p-2">
        <div class="col-1" *ngIf="isSideMenuVisible">
            <app-admin-side-menu [menuType]="menuType" (sideMenuChange)="onSideMenuChange($event)">
            </app-admin-side-menu>
        </div>
        <div [class.col-10]="isSideMenuVisible" [class.col-11]="!isSideMenuVisible">
            <div class="heading-container">
                <button class="center-content toggle-side-menu-button" (click)="toggleSideMenu()">
                    <mat-icon class="circle-button">
                        {{ isSideMenuVisible ? 'keyboard_arrow_left' : 'keyboard_arrow_right' }}
                    </mat-icon>
                </button>
                <div class="p-2 mt-1">
                    {{ currentHeading }}
                </div>
            </div>
            <div class="pt-2 pb-2">
                {{ currentDescription }}
            </div>
            <div class="row pt-1 pb-1">
                <div class="create-search-container">
                    <div class="col ml-2" *ngIf="stateNumber == 2">
                        <mat-tab-group class="report-type-tab-group"
                            (selectedTabChange)="filterListingBasedOnTab($event)">
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <mat-icon class="material-icons-outlined tab-icon">view_list</mat-icon>
                                    <span class="tab-title">Production</span>
                                </ng-template>
                            </mat-tab>
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <mat-icon class="material-icons-outlined tab-icon">publish</mat-icon>
                                    <span class="tab-title">Published</span>
                                </ng-template>
                            </mat-tab>
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <mat-icon class="material-icons-outlined tab-icon">local_offer</mat-icon>
                                    <span class="tab-title">Under Offer</span>
                                </ng-template>
                            </mat-tab>
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <mat-icon class="material-icons-outlined tab-icon">money</mat-icon>
                                    <span class="tab-title">Sold</span>
                                </ng-template>
                            </mat-tab>
                        </mat-tab-group>
                    </div>
                    <div class="toolbar">
                        <div *ngIf="isPrincipalAgent && this.stateNumber == 2">
                            <mat-button (click)="loadAllCompanyListings()" class="company-listings-button pt-2 pb-2"
                                id="company-listings-button">Company
                                Listings</mat-button>&nbsp;
                        </div>
                        <div class="search-wrapper col-3">
                            <mat-icon class="search-icon">search</mat-icon>
                            <input type="text" placeholder="Search" class="search-input"
                                (input)="searchListings($event)" />
                        </div>
                    </div>
                </div>
            </div>
            <mat-tab-group class="report-type-tab-group" [selectedIndex]="reportTypeTabNumber - 1"
                (selectedIndexChange)="navigateToReportTypeTab($event + 1)">
                <mat-tab *ngFor="let type of reportTypes">
                    <ng-template mat-tab-label>
                        <mat-icon class="material-icons-outlined tab-icon">
                            {{ type.icon }}
                        </mat-icon>
                        <span class="tab-title">
                            {{ type.value }}
                        </span>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
            <div *ngIf="reportTypeTabNumber === 1" class="single-container">
                <div class="card-container row">
                    <div class="listing-card col-12" *ngFor="let listing of displayedListings; let i = index">
                        <app-listing-card [listing]="listing" [users]="users" [currentUserIndex]="getUserIndex(i)"
                            (listingClicked)="goToListingOverview(listing)"
                            (listingClickedNewWindow)="goToListingOverviewNewWindow(listing)"
                            (listingCardSelected)="onListingCardSelected($event)" (listingUpdated)="onListingUpdated()">
                        </app-listing-card>
                    </div>
                </div>
                <div class="load-more-container" *ngIf="hasMoreListings">
                    <div class="loading-more" *ngIf="loadingMore">Loading more...</div>
                    <div class="scroll-hint" *ngIf="!loadingMore">
                        Showing {{ displayedListings.length }} of {{ filteredListings.length }} listings - scroll for more
                    </div>
                </div>
            </div>
            <div *ngIf="reportTypeTabNumber === 2">
                <div *ngFor="let group of propertyListingGroups | keyvalue">
                    <mat-card class="group-container">
                        <div class="group-heading">
                            <span class="paragraph">
                                {{ group.value?.groupName ?? 'Group Name Not Available' }}
                            </span>
                        </div>
                        <div class="card-container">
                            <div class="group-card">
                                <app-group-card [group]="group" (groupClicked)="goToListingGroupOverview(group)">
                                </app-group-card>
                            </div>
                            <div *ngFor="let listing of group?.value?.propertyListings; let i = index"
                                class="listing-card">
                                <app-listing-card [listing]="listing" [users]="users">
                                </app-listing-card>
                            </div>
                        </div>
                    </mat-card>
                </div>
            </div>
        </div>
    </div>
</main>